import { Text, Icons } from '@/theme/index';

export function RecomplyPermittedUseLabel() {
  return (
    <Text color="success" variant="h3" mb={1.5}>
      <Icons.Check color="success" sx={{ m: 0.75, mb: -0.75 }} />
      MY USE IS PERMITTED
    </Text>
  );
}
